import { TruckFlatbedIcon } from './TruckFlatbedIcon';

/**
 * author: Colton Wiscombe
 * id 4A29028B-25F3-423F-B924-BB93FAEC2DCF
 * name truck-flatbed
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-flatbed.svg
 * tags
 * - Automotive 
 * - Transportation + Road 
 */
export const TruckFlatbedTowIcon = TruckFlatbedIcon;
export default TruckFlatbedTowIcon